module.exports = __webpack_public_path__ + "static/media/branch.1edcc149.svg";